<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_st9"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <!--        <el-button type="primary" @click="getSelectEvent">获取选中</el-button>-->
        <el-button
          v-if="getLimit('changeList_search_button')"
          type="primary"
          @click="funcFilter()"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('changeList_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      stripe
      highlight-current-row
      border
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :footer-method="footerMethod"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="userPhone"
          title="手机号"
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="userPartyTypeName"
          title="角色"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.userPartyType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in userPartyTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="userName"
          title="用户名称"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="请输入用户名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="paidFeeType"
          :formatter="formatterPaidFeeType"
          title="收支类型"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.paidFeeType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in paidFeeTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="paidLineName"
          title="支付类型"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.paidLineType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in paidLineTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="paidItemName"
          title="消费项目"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.paidItem"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in paidItemOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="paidAmount"
          title="变动金额"
          width="200"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.paidAmountMin"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('paidAmountMin')"
            />
            <el-input
              v-model="listQuery.paidAmountMax"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('paidAmountMax')"
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="accountAmountBehind"
          title="余额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <!-- <el-input v-model="listQuery.accountAmount" placeholder="请输入内容" clearable /> -->
          <div class="for-input-range">
            <el-input
              v-model="listQuery.paidAccountAmountMin"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('paidAccountAmountMin')"
            />
            <el-input
              v-model="listQuery.paidAccountAmountMax"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('paidAccountAmountMax')"
            />
          </div>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="businessPerson"
          title="操作人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.businessPerson"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="变动时间"
          width="360"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { shipmentPaidRecord } from "@/api/invoice";

import { isNumber } from "@/utils/validate.js";
export default {
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      exportObj: {
        exportUrl: "/ntocc-basic-api/shipmentPaidRecord/exportChangeRecord", //导出接口
        name: "变更记录"
      },
      listQuery: {
        gmtCreatedRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        userPhone: "",
        userPartyType: "",
        paidFeeType: "",
        paidLine: "",
        paidItem: "",
        paidAmount: "",
        paidAmountMin: "",
        paidAmountMax: "",
        paidAccountAmountMin: "",
        paidAccountAmountMax: "",
        accountAmount: "",
        businessPerson: "",
        gmtCreateds: [],
        gmtCreatedStart: "",
        gmtCreatedEnd: ""
      },
      // Pagingconf: [],
      sumObject: {},
      paidFeeTypeOptions: [
        {
          label: "收入",
          value: "0",
          color: "gray"
        },
        {
          label: "支出",
          value: "1",
          color: "#0000ff"
        },
        {
          label: "余额转换",
          value: "2",
          color: "blue"
        }
      ],
      userPartyTypeOptions: [
        {
          label: "实际承运人",
          value: 0,
          color: "gray"
        },
        {
          label: "托运人",
          value: 1,
          color: "#0000ff"
        }
      ],
      paidLineTypeOptions: [
        {
          label: "在线支付",
          value: 0,
          color: "gray"
        },
        {
          label: "转账支付",
          value: 1,
          color: "#0000ff"
        }
      ],
      paidItemOptions: [
        {
          label: "预付运费",
          value: "1",
          color: "#0000ff"
        },
        {
          label: "到付运费",
          value: "2",
          color: "#0000ff"
        },
        {
          label: "回单运费",
          value: "3",
          color: "#0000ff"
        }
      ],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.findList();
  },
  methods: {
    isNumber4listQuery(key) {
      let val = this.listQuery[key];
      if (val !== "") {
        if (!isNumber(val)) {
          this.$message({ message: "请输入数字！", type: "error" });
        }
        val = parseFloat(val);
        if (isNaN(val)) {
          val = "";
        }
        this.$set(this.listQuery, key, val);
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        shipmentPaidRecord(this.listQuery).then(response => {
          this.tableData = response.data.records;
          // response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    formatterPaidFeeType({ cellValue }) {
      switch (cellValue) {
        case "0":
          return "收入";
        case "1":
          return "支出";
        case "2":
          return "余额转换";
        default:
          break;
      }
    },
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    } /*
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      if (columnIndex === 0) {
        if ($rowIndex === 0) {
          return 'col-blue'
        } else {
          return 'col-red'
        }
      }
    }, */,
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "paidAmount") {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>

<style></style>
